import React, {Fragment, useCallback, useEffect, useState} from 'react';
import {Trans} from '@common/i18n/trans';
import {useFormContext} from 'react-hook-form';
import { Button } from '@common/ui/buttons/button';
import { AddIcon } from '@common/icons/material/Add';
import { List, ListItem } from '@common/ui/list/list';
import { RateSheetPayload } from '../../requests/update-rate-sheet-settings';
import { now } from 'moment-timezone';
import { RateSheetItem } from './rate-sheet-item';
import { SubRateSheetMeta } from './rate-sheet-meta';
import { useSendRateSheet } from '@app_modules/requests/use-send-email-rate-sheet';
import { toast } from '@common/ui/toast/toast';
import { message } from '@common/i18n/message';

export function AnalysisRateSheetForm({id, market_rate_date, data_items, timeChange, loan_program_types}:{id: number, market_rate_date: string, data_items?: any, timeChange: any, loan_program_types: any}) {

  const form = useFormContext<RateSheetPayload>();
  const [items, setItems] = useState<RateSheetItem[]>(data_items.length ? data_items : [{key: "1"}]);
  const len = data_items ? data_items.length : 1;
  const [cnt, setCnt] = useState(len);
  const [last, setLast] = useState(len);

  useEffect(() => {
    setItems(items);
    setLast(last+1);
  }, [cnt]);

  const [subItems, setSubItems] = useState([]);
  const onAddSubItems = useCallback((pidx: number, itemSubItems: any) => {
    items[pidx]['subItems'] = itemSubItems;
    setSubItems(itemSubItems);
    // form.setValue('items', items);
	}, []);

  const removeParent =(canRemove: boolean, pidx: number) => {
    if (canRemove) {
      items.splice(pidx, 1);
      setCnt(cnt-1);
      // form.setValue('items', items);
    }
  }


  useEffect(() => {
    setItems(data_items);
    // form.setValue('items', items);
  }, [data_items, timeChange]);

  useEffect(() => {
    setItems(items);
    // form.setValue('items', items);
  }, [items,subItems]);

  const sendEmail = useSendRateSheet();


  return (
    <Fragment>
      
      <div className='gap-10 '>
        <div className='flex'>
          <div className='w-[90%] p-10'>
          <Button
            startIcon={<AddIcon />}
             variant="flat" color="primary"
            onClick={() => {
              items.push({key: last.toString(), 'subItems': [{key: "1", loan_program_type: "", investor_code: "", prompt: ""}]});
              setCnt(cnt+1);
            }}
            >
            <Trans message="Add Loan Product" />
          </Button>
          </div>
          <div className='w-[10%] p-10'>
            <Button
              variant="flat"
              color="green"
              onClick={() => {
                sendEmail.mutate({id: id}, {
                  onSuccess: (response: any) => {
                    toast(
                      message(`You have just sent the rate sheet to the investors.`),
                    );
                  },
                });
              }}
              disabled={sendEmail.isPending}
            >
              <Trans message="Email Rate Analysis" />

            </Button>
          </div>
        </div>
        <aside className="sticky top-10 w-[100%] flex">
          <List padding="p-0" className='scroll-p-8 overflow-y-scroll min-h-600 w-[900%]'>
          {items?.map((item: any, pidx: number) => (
            <ListItem
              className='border-b-1'
              key={`meta-${pidx}`}
            >
              <>
                <SubRateSheetMeta id={id} timeChange={timeChange} market_rate_date={market_rate_date} onAddSubItems={onAddSubItems} key={`sub-rate-${pidx}-${timeChange}`} pidx={pidx} item={item} removeParent={removeParent} loan_program_types={loan_program_types}/>
              </>
              </ListItem>
              ))}
          </List>
        </aside>
      </div>

    </Fragment>
  );
}
